import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DateUtil } from '../utils/date-util';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    private dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
    private dateTimeRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)$/;
    private utcDateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/;
    private localDateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)([\+-]\d{1,2}(?:\:\d{1,2}))$/;

    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (request.body && ['POST', 'PUT'].includes(request.method)) {
            // ✅ JSON
            if (!(request.body instanceof FormData)) {
                const normalizedBody = this.normalizeRequestDate(request.body);
                request = request.clone({ body: normalizedBody });
            }

            // ✅ FORM DATA
            if (request.body instanceof FormData) {
                const normalizedFormData = this.normalizeFormDataDate(request.body);
                request = request.clone({ body: normalizedFormData });
            }
        }

        return next.handle(request).pipe(map((val: HttpEvent<any>) => {
            if (val instanceof HttpResponse) {
                const body = val.body;
                this.convertDates(body);
            }
            return val;
        }));
    }

    private normalizeRequestDate(obj: any): any {
        if (!obj || typeof obj !== 'object') {
            return obj;
        }

        if (Array.isArray(obj)) {
            return obj.map(item => this.normalizeRequestDate(item));
        }

        const clone: any = { ...obj };

        Object.keys(clone).forEach(key => {
            const value = clone[key];

            if (value instanceof Date) {
                // 👉 TOÀN BỘ Date khi gửi request => date-only
                clone[key] = DateUtil.toDateOnly(value);
            } else if (typeof value === 'object') {
                clone[key] = this.normalizeRequestDate(value);
            }
        });

        return clone;
    }

    private normalizeFormDataDate(formData: FormData): FormData {
        const newFormData = new FormData();
        formData.forEach((value, key) => {
            // File → giữ nguyên
            if (value instanceof File) {
                newFormData.append(key, value);
            }
            // String date → normalize
            else if (typeof value === 'string' && this.isDateString(value)) {
                newFormData.append(key, this.normalizeDateString(value));
            }

            // Các kiểu khác
            else {
                newFormData.append(key, value);
            }
        });
        return newFormData;
    }


    private isDateString(value: string): boolean {
        return (
            /^\d{4}-\d{2}-\d{2}$/.test(value) ||
            /^\d{4}-\d{2}-\d{2}T.*Z$/.test(value)
        );
    }

    private normalizeDateString(value: string): string {
        return value.includes('T') ? value.substring(0, 10) : value;
    }

    private convertDates(object: Object) {
        if (!object || !(object instanceof Object)) {
            return;
        }

        if (object instanceof Array) {
            for (const item of object) {
                this.convertDates(item);
            }
        }

        for (const key of Object.keys(object)) {
            const value = object[key];

            if (value instanceof Array) {
                for (const item of value) {
                    this.convertDates(item);
                }
            }

            if (value instanceof Object) {
                this.convertDates(value);
            }

            if (typeof value === 'string' && (this.dateRegex.test(value) || this.dateTimeRegex.test(value) || this.utcDateRegex.test(value) || this.localDateRegex.test(value))) {
                object[key] = new Date(value);
            }
        }
    }
}
